import React from "react";
import SubcontractorPlaceholder from "@/pages/SubcontractorPlaceholder";
import { ShieldStar } from "@phosphor-icons/react";

export default function SubEvaluation() {
  return (
    <SubcontractorPlaceholder
      title="Değerlendirme / Puanlama"
      icon={ShieldStar}
      description="İş bitiminde taşeron performans puanlaması (AHP tabanlı çok kriterli değerlendirme)."
    />
  );
}
